import React from 'react';

export const RatingIcon = () => (
  <svg width="134" height="22" viewBox="0 0 134 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.80552 1.87908C10.1679 0.703388 11.8322 0.703396 12.1946 1.87908L13.9734 7.64942H19.7748C20.9697 7.64942 21.4835 9.16534 20.5348 9.89184L15.7857 13.5286L17.5904 19.3829C17.949 20.5462 16.6024 21.4837 15.6359 20.7436L11.0001 17.1935L6.36423 20.7436C5.39774 21.4837 4.05109 20.5462 4.4097 19.3829L6.21437 13.5286L1.46535 9.89184C0.516644 9.16533 1.03042 7.64942 2.22534 7.64942H8.02673L9.80552 1.87908Z"
      fill="#006AFF"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M37.8055 1.87908C38.1679 0.703388 39.8322 0.703396 40.1946 1.87908L41.9734 7.64942H47.7748C48.9697 7.64942 49.4835 9.16534 48.5348 9.89184L43.7857 13.5286L45.5904 19.3829C45.949 20.5462 44.6024 21.4837 43.6359 20.7436L39.0001 17.1935L34.3642 20.7436C33.3977 21.4837 32.0511 20.5462 32.4097 19.3829L34.2144 13.5286L29.4653 9.89184C28.5166 9.16533 29.0304 7.64942 30.2253 7.64942H36.0267L37.8055 1.87908Z"
      fill="#006AFF"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M65.8055 1.87908C66.1679 0.703388 67.8322 0.703396 68.1946 1.87908L69.9734 7.64942H75.7748C76.9697 7.64942 77.4835 9.16534 76.5348 9.89184L71.7857 13.5286L73.5904 19.3829C73.949 20.5462 72.6024 21.4837 71.6359 20.7436L67.0001 17.1935L62.3642 20.7436C61.3977 21.4837 60.0511 20.5462 60.4097 19.3829L62.2144 13.5286L57.4653 9.89184C56.5166 9.16533 57.0304 7.64942 58.2253 7.64942H64.0267L65.8055 1.87908Z"
      fill="#006AFF"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M93.8055 1.87908C94.1679 0.703388 95.8322 0.703396 96.1946 1.87908L97.9734 7.64942H103.775C104.97 7.64942 105.483 9.16534 104.535 9.89184L99.7857 13.5286L101.59 19.3829C101.949 20.5462 100.602 21.4837 99.6359 20.7436L95.0001 17.1935L90.3642 20.7436C89.3977 21.4837 88.0511 20.5462 88.4097 19.3829L90.2144 13.5286L85.4653 9.89184C84.5166 9.16533 85.0304 7.64942 86.2253 7.64942H92.0267L93.8055 1.87908Z"
      fill="#006AFF"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M121.806 1.87908C122.168 0.703388 123.832 0.703396 124.195 1.87908L125.973 7.64942H131.775C132.97 7.64942 133.483 9.16534 132.535 9.89184L127.786 13.5286L129.59 19.3829C129.949 20.5462 128.602 21.4837 127.636 20.7436L123 17.1935L118.364 20.7436C117.398 21.4837 116.051 20.5462 116.41 19.3829L118.214 13.5286L113.465 9.89184C112.517 9.16533 113.03 7.64942 114.225 7.64942H120.027L121.806 1.87908Z"
      fill="#006AFF"
    />
  </svg>
);
